import React from 'react';
// eslint-disable-next-line
import PropTypes from 'prop-types';
import { FormFeedback, Input } from 'reactstrap';

const renderField = ({
  componentClass = Input,
  input,
  label,
  meta: { touched, error, dirty, active, visited, warning },
  help,
  valueAsChildren,
  render,
  ...props
}) => {
  const Component = componentClass;

  const component = valueAsChildren ? (
    <Component {...input} {...props}>
      {input.value}
    </Component>
  ) : (
    <Component invalid={!!(error || warning) && touched} {...input} {...props} />
  );

  const flags = process.env.NODE_ENV === 'development' && (
    <div className="form-group-flags">
      {dirty && (
        <span className="field-dirty" title="Dirty">
          D
        </span>
      )}
      {active && (
        <span className="field-active" title="Active">
          A
        </span>
      )}
      {visited && (
        <span className="field-visited" title="Visited">
          V
        </span>
      )}
      {touched && (
        <span className="field-touched" title="Touched">
          T
        </span>
      )}
    </div>
  );

  const feedback = <FormFeedback>{error || warning}</FormFeedback>;

  return render ? (
    render({ component, feedback, flags, input, props })
  ) : (
    <React.Fragment>
      {component}
      {props.type !== 'hidden' && feedback}
      {props.type !== 'hidden' && flags}
    </React.Fragment>
  );
};

export default renderField;



// WEBPACK FOOTER //
// ./src/partials/form/render-field.js